import NotificationBox from 'components/NotificationBox/NotificationBox';
import React from 'react';
import { selectUserPermissions } from 'redux/auth/AuthSlice';
import { useAppSelector } from 'redux/hooks';
import { NOTIFICATION_TYPES, USER_PERMISSIONS } from 'utils/common-constants';
import { hasPermission } from 'utils/commonFunctions/CommonFunctions';
import style from './ProtectedRoute.module.scss';


interface ProtectedRouteProps {
  element: React.ReactElement;
  requiredPermissions: USER_PERMISSIONS[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  requiredPermissions,
}) => {
  const userPermissions = useAppSelector(selectUserPermissions);
  const hasRequiredPermission = hasPermission(
    userPermissions,
    requiredPermissions
  );

  if (!hasRequiredPermission) {
    return (
      <div className={style['access-denied-container']}>
        <NotificationBox
          notificationContent={{
            type: NOTIFICATION_TYPES.ERROR,
            header: 'Access Denied',
            textContent: ` You don't have permission to access this page. Please contact your administrator.`,
          }}
          onCta={() => {}}
        />
        <div></div>
      </div>
    );
  }

  return element;
};

export default ProtectedRoute;
